/** Method key for the hook that hides an unnamed logo from assistive technology (see `logo.ts`). */
export const decorative = Symbol('decorative')
